import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { mediaUrl } from "@/lib/api";
import { useStoreBase } from "@/lib/store";

function step(el) {
  if (!el) return;
  const card = el.querySelector("[data-abp-card]");
  if (!card) return;
  const gap = 16;
  const width = card.getBoundingClientRect().width + gap;
  const half = el.scrollWidth / 2;
  let next = el.scrollLeft + width;
  if (half > width && next >= half - 2) next -= half;
  el.scrollTo({ left: Math.max(0, next), behavior: "smooth" });
}

export default function AbpHomeRail({ config }) {
  const { base } = useStoreBase();
  const scroller = useRef(null);
  const home = config?.abp_capabilities;
  const bundles = (home?.bundles || []).filter((b) => b && b.slug);
  const loop = bundles.length > 1 ? [...bundles, ...bundles] : bundles;

  useEffect(() => {
    if (bundles.length < 2) return undefined;
    const t = setInterval(() => {
      const el = scroller.current;
      if (!el || el.dataset.paused === "1") return;
      step(el);
    }, 2800);
    return () => clearInterval(t);
  }, [bundles.length]);

  if (!config?.abp_capabilities_active || bundles.length === 0) return null;
  const title = home?.section_title || "Product Mixture & More";

  return (
    <section className="w-full min-w-0 max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-5 sm:py-8 overflow-hidden" data-testid="abp-home-rail">
      <h2 className="text-lg sm:text-2xl font-extrabold text-stone-900 mb-4 break-words" data-testid="abp-section-title">{title}</h2>
      <div
        ref={scroller}
        className="w-full min-w-0 flex gap-3 sm:gap-4 overflow-x-auto no-scrollbar snap-x snap-mandatory"
        data-testid="abp-rail-scroller"
        onMouseEnter={(e) => { e.currentTarget.dataset.paused = "1"; }}
        onMouseLeave={(e) => { e.currentTarget.dataset.paused = "0"; }}
        onTouchStart={(e) => { e.currentTarget.dataset.paused = "1"; }}
        onTouchEnd={(e) => { e.currentTarget.dataset.paused = "0"; }}
      >
        {loop.map((b, i) => (
          <Link
            key={`${b.id || b.slug}-${i}`}
            to={`${base}/mix/${b.slug}`}
            data-abp-card="1"
            data-testid={`abp-card-${b.slug}`}
            className="snap-start shrink-0 w-[calc((100%-1.5rem)/3)] md:w-[calc((100%-4rem)/5)] lg:w-[calc((100%-5rem)/6)] text-center min-w-0"
          >
            <span className="block aspect-square rounded-full overflow-hidden bg-stone-100 ring-1 ring-stone-200">
              {b.image ? (
                <img src={mediaUrl(b.image)} alt="" className="w-full h-full object-cover" />
              ) : (
                <span className="flex h-full items-center justify-center text-xs font-bold text-stone-400 px-2">{b.title}</span>
              )}
            </span>
            <span className="mt-2 block text-xs sm:text-sm font-semibold text-stone-800 leading-tight line-clamp-2">{b.title}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
